import React from 'react';
import { styled } from '@mui/material/styles';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

const StyledCard = styled(Card)`
  width: 100%;
  border-radius: 25px;
  background-color: transparent;
` as typeof Card;

const StyledCardMedia = styled(CardMedia)`
  width: 28px;
  height: 28px;
  cursor: pointer;
  aspect-ratio: 1/1;
  border-radius: 10px;
` as typeof CardMedia;

const AvatarSkeleton = styled(Skeleton)`
  transform: unset; 
  transform-origin: unset;
  border-radius: 50%;
` as typeof Skeleton;

const TitleSkeleton = styled(Skeleton)`
  max-width: 100%;
  width: auto;
  display: flex;
  flex-direction: row;
` as typeof Skeleton;

const NotificationCardSkeleton: React.FC = () => {
  return (
    <StyledCard variant="outlined">
      <CardHeader
        avatar={
          <AvatarSkeleton>
            <StyledCardMedia component="img" src="" alt="" />
          </AvatarSkeleton>
        }
        title={
          <TitleSkeleton>
            <Typography variant="h4">x</Typography>
          </TitleSkeleton>
        }
      />
    </StyledCard>
  );
};

export default NotificationCardSkeleton;